module.exports = __webpack_public_path__ + "img/arch-1.59521e39.svg";